module.exports = __webpack_public_path__ + "img/sofa.4d0dd439.jpg";